import { withStyles } from '@material-ui/core/styles'

const styles = {
	container: {
		padding: '60px 60px 80px 60px',
	},
	fontFamily: {
		fontFamily: 'Lato',
		color: '#33495f',
	},
	title: {
		marginBottom: '40px',
	},
	absoluteCenter: {
		position: 'absolute',
		top: 'calc(50% - 20px)',
		left: 'calc(50% - 20px)',
	},
}

export default function (hook) {
	return withStyles(styles, {withTheme: true})(hook)
}
